import { getMbsTool, resolveApiBase } from "./dataFetcherConfig";

export const dataFetcher = async (
    url: string,
    options?: RequestInit,
    type: "json" | "blob" | "text" = "json",
) => {
    const apiBase = resolveApiBase(url);

    const sign = url.includes("?") ? "&" : "?";
    // Sent as x-live-share-report-id so the server can pick the per-report cookie
    const liveShareReportID =
        typeof window !== "undefined" ? sessionStorage.getItem("mbs-live-share-report-id") : null;
    const mergedOptions: RequestInit = liveShareReportID
        ? {
              ...options,
              headers: {
                  ...(options?.headers || {}),
                  "x-live-share-report-id": liveShareReportID,
              },
          }
        : (options as RequestInit);
    const res = await fetch(`${apiBase}${url}${sign}mbs_tool=${getMbsTool()}`, mergedOptions);

    if (!res.ok) {
        console.log(res);
        throw new Error(`Failed to fetch data. ${res.status}`);
    }

    if (type === "blob") return res.blob();
    else if (type === "text") return res.text();
    else return res.json();
};

export const mockDataFetcher = <T>(mockData: T) => {
    return Promise.resolve({ data: mockData });
};
